import { makeStyles } from '@mui/styles';
export default makeStyles(() => ({
  titleRow: {
    display: 'inline-flex',
    alignItems: 'baseline',
    gap: 12,
    flexWrap: 'wrap'
  },
  subtitle: {
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.6)'
  },
  content: {
    minWidth: '520px'
  },
  total: {
    marginBottom: '12px'
  },
  monthRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '16px'
  },
  monthChip: {
    fontWeight: 600
  },
  endedChip: {
    marginLeft: '8px'
  },
  headCell: {
    fontWeight: 700
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    padding: '24px 0'
  }
}));